import { CSSProperties } from 'react';

export const panelStyle: CSSProperties = {
  position: 'relative',
  background: 'rgba(45, 55, 72, 0.95)',
  border: '1px solid rgba(255, 255, 255, 0.2)',
  borderRadius: '8px',
  padding: '20px 24px',
  boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
  backdropFilter: 'blur(10px)',
  minWidth: '280px',
  fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
};

export const pointerStyle: CSSProperties = {
  content: '""',
  position: 'absolute',
  top: '100%',
  left: '30px',
  width: '0',
  height: '0',
  borderLeft: '12px solid transparent',
  borderRight: '12px solid transparent',
  borderTop: '15px solid rgba(45, 55, 72, 0.95)',
};

export const pointerBorderStyle: CSSProperties = {
  // content: '""',
  // position: 'absolute',
  // top: '100%',
  // left: '29px',
  // width: '0',
  // height: '0',
  // borderLeft: '13px solid transparent',
  // borderRight: '13px solid transparent',
  // borderTop: '16px solid rgba(255, 255, 255, 0.42)',
  // zIndex: '-1',
};

export const blockTitleStyle: CSSProperties = {
  color: '#ffffff',
  fontSize: '18px',
  fontWeight: '600',
  margin: '0 0 16px 0',
  letterSpacing: '0.5px',
};

export const infoRowStyle: CSSProperties = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: '8px',
  color: '#e2e8f0',
  fontSize: '14px',
};

export const lastRowStyle: CSSProperties = {
  ...infoRowStyle,
  marginBottom: '0',
};

export const infoLabelStyle: CSSProperties = {
  fontWeight: '400',
  letterSpacing: '0.3px',
};

export const infoValueStyle: CSSProperties = {
  fontWeight: '600',
  color: '#ffffff',
  fontSize: '15px',
};

export const containerStyle: CSSProperties = {
  margin: '0',
  padding: '50px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  minHeight: '100vh',
};